import Button from '@rio-cloud/rio-uikit/Button';
import type { Control } from 'react-hook-form';
import { FormattedMessage, type IntlShape } from 'react-intl';

import { ControlSize } from '#components/form/ControlSize.ts';
import { ControlledFormInput } from '#components/form/FormInput.tsx';
import type { OrderFormCollection } from '#features/orderForm/model/OrderFormCollection.ts';

import type { OrderFormData } from '../model/OrderFormValidation.ts';

export const OrderTitleInput = ({
    intl,
    control,
    onClick,
    orderNumberPrefix,
    showGenerateButton = false,
}: {
    intl: IntlShape;
    control: Control<OrderFormData> | Control<OrderFormCollection>;
    onClick?: () => Promise<void>;
    orderNumberPrefix?: string;
    showGenerateButton?: boolean;
}) => {
    const name = orderNumberPrefix ? `${orderNumberPrefix}.number` : 'number';
    return (
        <div className='width-100pct width-200-sm'>
            <ControlledFormInput
                size={ControlSize.LARGE}
                label={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.step1.order-title',
                })}
                control={control}
                name={name}
                action={
                    showGenerateButton ? (
                        <Button
                            variant='link-inline'
                            className='text-color-gray text-size-12'
                            autoTrackingKey='intl-msg:ordercom-cloud-frontend.orders.create-dialog.step1.generate'
                            onClick={onClick}
                        >
                            <FormattedMessage
                                id={'intl-msg:ordercom-cloud-frontend.orders.create-dialog.step1.generate'}
                            />
                        </Button>
                    ) : undefined
                }
            />
        </div>
    );
};
